import React from 'react'
import { useTranslation } from 'react-i18next'

import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox'
import { InputNumber, InputNumberProps } from 'primereact/inputnumber'
import { TooltipOptions } from 'primereact/tooltip/tooltipoptions'
import { classNames } from 'primereact/utils'

export interface InputNumberToggleableProps extends InputNumberProps {
  checked: boolean
  onCheckedChange: (event: CheckboxChangeEvent) => void
  checkboxTooltip?: string
  checkboxTooltipOptions?: TooltipOptions
}

export const InputNumberToggleable: React.FC<InputNumberToggleableProps> = ({
  checked,
  onCheckedChange,
  checkboxTooltip,
  checkboxTooltipOptions,
  disabled,
  ...props
}) => {
  const { t } = useTranslation()

  if (disabled)
    return <InputNumber className="w-full" disabled={disabled} {...props} />

  return (
    <div className="p-inputgroup">
      <span
        className={classNames('p-inputgroup-addon', { 'p-disabled': !checked })}
      >
        <Checkbox
          checked={checked}
          onChange={onCheckedChange}
          tooltip={
            checkboxTooltip ||
            t('components.inputs.inputNumberToggleable.checkBoxTooltip')
          }
          tooltipOptions={{
            ...checkboxTooltipOptions,
            position: checkboxTooltipOptions?.position || 'left',
          }}
        />
      </span>
      <InputNumber disabled={disabled || !checked} {...props} />
    </div>
  )
}
